// angular
// 	.module("HeroPRO")
// 	.directive('hpProgressIndicator', progressIndicator);

import './desktop/desktopProgress.scss';

export default function progressIndicator() {
    const progressController = function () {
        const vm = this;


        init();

        /*= =======================================
		 =            Public Functions            =
		 ======================================== */

        vm.click = function (step) {
            vm.clickHandler()(step);
        };


        /* -----  End of Public Functions  ------*/

        /*= =======================================
		 =            Private Functions            =
		 ======================================== */
        function init() {

        }
    };

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            progressSteps: '=',
            clickHandler: '&?',
        },
        require: '^form',
        template: require('./desktop/desktopProgress.html'),
        // templateUrl: 'app/common/progressIndicator/desktop/desktopProgress.html',
        controller: progressController,
        controllerAs: 'progress',
        bindToController: true,
    };
}



// WEBPACK FOOTER //
// ./src/app/common/progressIndicator/hpProgressIndicator.js